import { useState } from "react";

import {
  Button,
  ButtonIconWithLabel,
  Icon_Checkmark24,
  Icon_LinkWeb24,
} from "@shapr3d/frontend-lib";
import classNames from "classnames";

import useTranslation from "../../../../../hooks/useTranslation";

import style from "./CopyLinkButton.module.css";

interface CopyLinkButtonProps {
  onCopyLink: () => boolean | Promise<boolean>;
  onCopy?: () => void;
  isDisabled: boolean;
}

export const CopyLinkButton = ({ onCopyLink, onCopy, isDisabled }: CopyLinkButtonProps) => {
  const { t, m } = useTranslation();
  const [copySuccessVisible, setCopySuccessVisible] = useState(false);

  const handleCopyClick = async () => {
    const isCopied = await onCopyLink();
    if (!isCopied) {
      return;
    }

    setCopySuccessVisible(true);
    setTimeout(() => {
      setCopySuccessVisible(false);
    }, 1000);

    onCopy?.();
  };

  return (
    <div className={style.copyLinkContainer}>
      <Button variant="grayscale" onClick={handleCopyClick} disabled={isDisabled}>
        <ButtonIconWithLabel icon={<Icon_LinkWeb24 />} label={t(m.MembersPage.CopyLink)} />
      </Button>
      <div className={classNames(style.copySuccessContainer, copySuccessVisible && style.visible)}>
        <Icon_Checkmark24 />
        <span>{t(m.MembersPage.Copied)}</span>
      </div>
    </div>
  );
};
